<div class="modal-md">
    <div class="modal-content">
        <div class="modal-header border-0 pl-0 pb-0">
           
        </div>
        <div class="modal-body">
           
            <div class="form-row justify-content-center">                  
                <div class="d-flex">
                    <p>{{message}}</p>
                </div>
            </div>
               

                <div class="form-row justify-content-center">
                  
                    <div class="d-flex">
                        <ul class="pager kg-request-btn text-center">
                            <li>
                                <button type="button" class="btn btn-save" (click)="okClick()">
                                    Ok
                                </button>
                            </li>
                            <li>
                                <button type="button" class="btn btn-cancel confirm-btn-cancel" (click)="onCloseClick()">
                                    Cancel
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            
        </div>
    </div>
</div>